import { ConfigType } from 'src/graphql';
import { EFormVariant } from 'src/typings/base-types';
import { TFieldsTemplateUnion } from 'src/utils/assetsFields/assetsFields.types';

export type TStorageArgs = {
  configType: ConfigType;
};

export const Storage = ({ configType }: TStorageArgs): TFieldsTemplateUnion[] => {
  const isDisabled = configType === ConfigType.CanaryNetwork;
  return [
    {
      name: 'name',
      type: 'text',
      label: 'Asset Name',
      formView: EFormVariant.Express,
    },
    {
      name: 'geoTagLocation',
      type: 'location',
      label: 'Location',
      tooltipText: 'Parent market already has location',
      formView: EFormVariant.Express,
    },
    {
      name: 'prosumptionKwhProfile',
      type: 'file',
      label: 'Upload Profile',
      tooltipText: 'Please upload storage prosumption profile here. ',
      formView: EFormVariant.Express,
      disabled: isDisabled,
    },
  ];
};
